import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "person",
  "use": "person-usage",
  "viewBox": "0 0 15.867 16.647",
  "content": "<symbol viewBox=\"0 0 15.867 16.647\" id=\"person\"><path d=\"M7.934 9C5.599 9 0 10.26 0 13.378v3.27h15.867v-3.27C15.867 10.26 10.269 9 7.934 9zm6.933 6.647H1v-2.27C1 11.283 5.489 10 7.934 10s6.934 1.283 6.934 3.378v2.269zM7.758 7.648c2.067 0 3.748-1.715 3.748-3.824S9.825 0 7.758 0C5.686 0 4 1.715 4 3.824s1.686 3.824 3.758 3.824zm0-6.648c1.515 0 2.748 1.267 2.748 2.824S9.273 6.648 7.758 6.648C6.236 6.648 5 5.381 5 3.824S6.236 1 7.758 1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./application/components/dumb/icon/src/person.svg
// module id = 178
// module chunks = 0